export function mobileContainsOnlyCountryCode(mobileString) {
  if (!mobileString || typeof mobileString !== 'string') {
    return false
  }

  const countryCodeRegex = /^(\+?\d{1,3}|\d{1,4})$/

  return countryCodeRegex.test(mobileString)
}

export function isMobileEmpty(mobileString) {
  return mobileContainsOnlyCountryCode(mobileString) || !mobileString
}
